import { FormattedMessage } from 'react-intl';
import { ProgressBar } from '@ets/design-system';
import { getAppLocation } from '_common/utils/getAppLocation';
import LogoContainer from '_common/components/LogoContainer/LogoContainer';

import styles from './LoadingPage.module.scss';

const LOADING_LABEL: Record<Common.Product, string> = {
  editor: 'LOADING_DODOC',
  pdf: 'LOADING_DOPDF',
  presentation: 'LOADING_DOPPT',
};

const LoadingPage = () => {
  const appLocation = getAppLocation() as keyof typeof LOADING_LABEL;

  const loadingMessageId = LOADING_LABEL[appLocation] ?? 'LOADING_DODOC';

  return (
    <div className={styles.container}>
      <div className={styles.logo}>
        <div className={styles.logoContainer}>
          <LogoContainer size="large" expanded color="blue" testId="loading-page-logo" />
        </div>
        <div style={{ marginTop: '4rem' }}>
          <ProgressBar variant="primary-dark" size="m" testId="loading-page">
            <FormattedMessage id={loadingMessageId} />
          </ProgressBar>
        </div>
      </div>
    </div>
  );
};

export default LoadingPage;
